module.exports = __webpack_public_path__ + "img/icon-logo.b532bcf2.png";